import type { CityConfig } from "../city-template/types";

export const fresnoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fresno",
  state: "California",
  stateAbbr: "CA",
  slug: "fresno",
  route: "/fresno",
  title: "Emergency Passport Fresno, CA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Fresno, CA — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Central Valley travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Fresno, CA",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fresno and Central Valley travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fresno%20California%20skyline%20at%20sunset%20with%20downtown%20high-rise%20buildings%2C%20agricultural%20fields%20and%20orchards%20visible%20in%20the%20foreground%2C%20Sierra%20Nevada%20mountains%20in%20the%20distant%20background%2C%20warm%20golden%20Central%20Valley%20light%2C%20clean%20modern%20urban%20skyline%2C%20professional%20cityscape%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20vibrant%20agricultural%20city%20scene&width=1800&height=700&seq=fresno-hero-001&orientation=landscape",
  heroImageAlt: "Fresno California skyline at sunset with downtown buildings and Sierra Nevada mountains",
  geoPosition: "36.7378;-119.7871",
  geoPlacename: "Fresno, California",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "San Francisco Passport Agency",
    address: "95 Hawthorne St Suite 200, San Francisco, CA 94105",
    distance: "Located in San Francisco — approximately 185 miles from Fresno via CA-99 and I-580",
  },
  nearbyCitiesZips: [
    { name: "Fresno", zips: "93650, 93701–93712, 93714, 93715, 93716, 93717, 93718, 93720–93730, 93740, 93741, 93744, 93745, 93747, 93750, 93755, 93760, 93761, 93764, 93765, 93771–93779, 93786, 93790, 93791, 93792, 93793, 93794" },
    { name: "Clovis", zips: "93611, 93612, 93613, 93619" },
    { name: "Madera", zips: "93636, 93637, 93638, 93639" },
    { name: "Visalia", zips: "93277, 93278, 93279, 93291, 93292" },
    { name: "Hanford", zips: "93230, 93232" },
    { name: "Tulare", zips: "93274, 93275" },
    { name: "Reedley", zips: "93654" },
    { name: "Sanger", zips: "93657" },
    { name: "Selma", zips: "93662" },
    { name: "Kerman", zips: "93630" },
    { name: "Kingsburg", zips: "93631" },
    { name: "Parlier", zips: "93648" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Valley departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Los Angeles", route: "/los-angeles" },
    { name: "Fast passport renewal in San Diego", route: "/san-diego" },
    { name: "Emergency passport help in San Francisco", route: "/san-francisco" },
    { name: "Urgent passport services in San Jose", route: "/san-jose" },
    { name: "Same-day passport help in Sacramento", route: "/sacramento" },
    { name: "Rush passport services near Bakersfield", route: "/bakersfield" },
    { name: "Passport courier services in Long Beach", route: "/long-beach" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fresno remotely via secure courier. We do not have a walk-in office in Fresno — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Central Valley travelers.",
  fpcOfficeAddress: "447 Sutter St, San Francisco, CA 94108",
  fpcOfficeDistance: "Serving all of Central California",
  serviceAreaIntro: "From downtown Fresno to the Clovis area, from the agricultural communities to the foothills — Fast Passport Center serves the entire Fresno-Clovis metro and the broader Central Valley. We regularly help travelers from Madera, Visalia, Hanford, and Tulare get their passports fast.",
  nearbyCitiesIntro: "We serve all Fresno neighborhoods and nearby Central Valley cities including Clovis, Madera, Visalia, Hanford, Tulare, Reedley, Sanger, and Selma. If you are in the San Joaquin Valley, we have you covered.",
  howItWorksIntro: "Most Fresno travelers complete everything online and ship documents overnight. No need to drive to Los Angeles or wait in line at the regional agency.",
  mistakesIntro: "Fresno travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fresno and Central Valley travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fresno? Here are the most common ones we hear from Central Valley travelers.",
  statePageRoute: "/states/california",
  statePageName: "California",
  dmvWebsite: "https://www.dmv.ca.gov",
  dmvLabel: "California DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Central Valley international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Elena R.",
      location: "Fresno, CA",
      rating: 5,
      text: "My flight to Mexico City was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved my family vacation.",
      service: "Emergency Passport",
    },
    {
      name: "Michael D.",
      location: "Clovis, CA",
      rating: 5,
      text: "Needed to renew my passport for a business trip to Tokyo. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah J.",
      location: "Visalia, CA",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Italy. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "David P.",
      location: "Madera, CA",
      rating: 5,
      text: "As a frequent international traveler from the Central Valley, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "fresno-1",
      name: "Fresno Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2305 Tulare St",
      city: "Fresno",
      state: "CA",
      zip: "93721",
      phone: "(559) 445-5254",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Fresno",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Central Valley. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "fresno-2",
      name: "Clovis Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "45 N Willow Ave",
      city: "Clovis",
      state: "CA",
      zip: "93611",
      phone: "(559) 299-1641",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Old Town Clovis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Busy location — book appointments 2+ weeks in advance. Limited weekend hours.",
      icon: "ri-mail-line",
    },
    {
      id: "fresno-3",
      name: "Visalia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2345 W Walnut Ave",
      city: "Visalia",
      state: "CA",
      zip: "93277",
      phone: "(559) 625-3266",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.0 miles from downtown Visalia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern San Joaquin Valley. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "fresno-4",
      name: "Madera Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "216 W Yosemite Ave",
      city: "Madera",
      state: "CA",
      zip: "93637",
      phone: "(559) 674-8532",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Madera",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Central Valley residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "fresno-5",
      name: "Hanford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Ivy St",
      city: "Hanford",
      state: "CA",
      zip: "93230",
      phone: "(559) 582-5311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from Hanford City Hall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Kings County residents. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "fresno-6",
      name: "Fresno County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "2221 Tulare St",
      city: "Fresno",
      state: "CA",
      zip: "93721",
      phone: "(559) 600-3471",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.2 miles from Fresno City Hall",
      website: "https://www.fresnocountyca.gov/",
      websiteLabel: "Fresno County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to San Francisco", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Central Valley Agriculture Business", agency: "No special handling", fpc: "Yes — agribusiness travel document coordination" },
    { feature: "Multi-City Valley Coverage", agency: "Fresno only — visit in person", fpc: "Yes — serve Visalia, Madera, Hanford, Tulare" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Central Valley photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Central Valley acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fresno applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the San Francisco regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Central Valley families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Central Valley travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fresno." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fresno address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fresno before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fresno for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most Central Valley travelers — without the 3 hour drive to San Francisco." },
    { q: "How fast can I renew my passport in Fresno?", a: "Fast Passport Center offers fast passport renewal in Fresno in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my Europe trip?", a: "If your passport expires soon before a Europe trip, contact Fast Passport Center immediately. Many countries require your passport to be valid for at least 3–6 months beyond your entry date. We can expedite your passport renewal in Fresno in 24–48 hours so you don't miss your flights." },
    { q: "Can I get a same-day passport appointment near Fresno?", a: "Same-day passport appointments are only available at the San Francisco Regional Passport Agency for documented life-or-death emergencies, which is approximately 185 miles from Fresno via CA-99 and I-580. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Central Valley residents." },
    { q: "Can I expedite a child passport in Fresno?", a: "Yes. Fast Passport Center expedites child passports in Fresno for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Central Valley families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fresno with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    {
      q: "How fast can I get a passport in Fresno?",
      a: "With Fast Passport Center's emergency courier service, Fresno travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays.",
    },
    {
      q: "Do I need to drive to the San Francisco Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change.",
    },
    {
      q: "Where are the closest passport acceptance facilities in Fresno?",
      a: "Popular options include the Fresno Main Post Office (93721), Clovis Post Office (93611), Visalia Post Office (93277), and Fresno County Clerk (93721). All require appointments. We help you find the most convenient location and schedule your visit.",
    },
    {
      q: "Can I get a same-day passport in Fresno?",
      a: "Same-day passports are only available at the San Francisco Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 3 hour drive to San Francisco.",
    },
    {
      q: "What if I live in a smaller Central Valley town?",
      a: "We serve the entire San Joaquin Valley including Madera, Visalia, Hanford, Tulare, Reedley, Sanger, Selma, Kerman, and Kingsburg. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed.",
    },
    {
      q: "How much does expedited passport service cost in Fresno?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline.",
    },
    {
      q: "Do you help with passport photos in Fresno?",
      a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Fresno and Clovis offer passport photo services. We review your photos before submission to ensure they meet State Department standards.",
    },
    {
      q: "What documents do I need for a first-time passport in Fresno?",
      a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk.",
    },
    {
      q: "Can you help with a child's passport in Fresno?",
      a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Central Valley families through the entire process and help schedule acceptance clerk appointments.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fresno", address: "2020 W Shaw Ave, Fresno, CA 93711", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Clovis", address: "1155 Shaw Ave, Clovis, CA 93612", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Fresno", address: "6730 N Fresno St, Fresno, CA 93710", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "UPS Store — Visalia", address: "4009 S Mooney Blvd, Visalia, CA 93277", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Fresno", address: "4840 N First St, Fresno, CA 93726", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Rite Aid — Madera", address: "1840 E Cleveland Ave, Madera, CA 93638", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/" },
    { name: "Postal Annex — Clovis", address: "90 W Shaw Ave, Clovis, CA 93612", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM", website: "https://www.postalannex.com/" },
    { name: "Costco — Fresno", address: "4500 W Shaw Ave, Fresno, CA 93722", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    {
      name: "DMV — Fresno",
      address: "655 W Olive Ave, Fresno, CA 93728",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "DMV — Clovis",
      address: "2200 W Cleveland Ave, Madera, CA 93637",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Passport-ready photo services available. Online appointment booking.",
      featured: false,
    },
    {
      name: "DMV — Visalia",
      address: "1712 S Mooney Blvd, Visalia, CA 93277",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID processing. Walk-ins limited — book online first.",
      featured: false,
    },
    {
      name: "DMV — Hanford",
      address: "530 W 7th St, Hanford, CA 93230",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Full-service center for Kings County residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "FAT",
      name: "Fresno Yosemite International Airport",
      distance: "6 miles from downtown Fresno",
      address: "5175 E Clinton Way, Fresno, CA 93727",
      note: "The primary airport for Central California. International flights to Mexico and connections to major hubs for global travel.",
      flightUrl: "https://www.fresno.gov/departments/airport/",
      flightLabel: "Fresno Airport Info",
      featured: true,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "220 miles from Fresno",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Major international hub for long-haul flights to Asia, Europe, and South America. Accessible via I-5.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
    {
      code: "SFO",
      name: "San Francisco International Airport",
      distance: "185 miles from Fresno",
      address: "San Francisco, CA 94128",
      note: "Major international hub for transpacific flights. Accessible via CA-99 and I-580.",
      flightUrl: "https://www.flysfo.com/",
      flightLabel: "SFO Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the California Department of Public Health Vital Records. Online, mail, or in-person options available for Fresno County residents.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through California CDPH Vital Records. Required for estate and legal matters in the Central Valley.", url: "https://www.cdph.ca.gov/Programs/CHSI/Pages/Vital-Records.aspx" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Fresno County Clerk. Certified copies available for name changes and legal purposes in Fresno.", url: "https://www.fresnocountyca.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Fresno County Superior Court. Required for name change passport corrections and legal documentation.", url: "https://www.fresno.courts.ca.gov/" },
  ],
};